import type { SheetContainerA11yProps } from './containerA11yProps';

export const sheetContainerA11yProps: SheetContainerA11yProps = {
  accessible: null,
  accessibilityRole: null,
  accessibilityLabel: null,
};
